export const notes = state => state.notes.items

export const noteById = state => id => _.find(notes(state), {id})

export const notesByReference = state =>
    (reference_type, reference_id) => {
        reference_id = parseInt(reference_id)
        return _.filter(notes(state), {reference_type, reference_id}).reverse()
    }

export const latestNoteByProjectId = (state, getters) => id => {
    let notes = getters.notesByReference('project', id)

    return _.maxBy(notes, note => moment(note.created_at).unix())
}

export const latestNoteByTaskId = (state, getters) => id => {
    let notes = getters.notesByReference('task', id)

    return _.maxBy(notes, note => moment(note.created_at).unix())
}

export const latestNoteMessageByProjectId = (state, getters) => id => {
    let latestNote = getters.latestNoteByProjectId(id)
    return latestNote ? latestNote.message : ''
}

export const latestNoteMessageByTaskId = (state, getters) => id => {
    let latestNote = getters.latestNoteByTaskId(id)
    return latestNote ? latestNote.message : ''
}

export const actorNameByNote = (state, getters) => ({actor_id, actor_type}) => {
    return actor_type == 'contact' ?
        getters.contactNameById(actor_id) :
        getters.userNameById(actor_id)
}